export default __webpack_public_path__ + "static/media/thumbnail.7b9952a9.png";